import { render, staticRenderFns } from "./CompletedCampaigns.vue?vue&type=template&id=5e42f5bd&scoped=true"
import script from "./CompletedCampaigns.vue?vue&type=script&lang=ts"
export * from "./CompletedCampaigns.vue?vue&type=script&lang=ts"
import style0 from "./CompletedCampaigns.vue?vue&type=style&index=0&id=5e42f5bd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e42f5bd",
  null
  
)

export default component.exports